module.exports = __webpack_public_path__ + "img/eit3-flow.532c4440.png";